import { Link } from 'react-router-dom';
import HoorayFooterLogo from '../../assets/Hooray-Assets/Logo/hooray-logo.svg';
import { MapPinIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

function Footer() {
  const currentYear = new Date().getFullYear();

  // Define color classes based on hooray-red background
  const footerBgClass = 'bg-hooray-red'; 
  const headingColorClass = 'text-white'; 
  const textColorClass = 'text-white/90'; 
  const mutedTextColorClass = 'text-white/70'; 
  const linkHoverColorClass = 'hover:text-hooray-yellow'; 

  return (
    <footer className={`${footerBgClass} py-12`}> {/* Increased padding slightly */}
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            {/* Added Footer Logo */}
            <img 
              src={HoorayFooterLogo} 
              alt="Hooray Power Logo" 
              className="h-14 w-auto mb-4" // Increased height from h-10 to h-14
            />
            {/* <h3 className={`text-xl font-semibold mb-4 font-mont ${headingColorClass}`}>Hooray Power</h3> Removed heading text */}
            <p className={`mb-4 ${textColorClass}`}>
              Providing reliable electricity backup solutions to homes and businesses since 2018.
            </p>
            <p className={`${mutedTextColorClass}`}>
              &copy; {currentYear} Hooray Power. All rights reserved.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className={`text-xl font-semibold mb-4 font-mont ${headingColorClass}`}>Quick Links</h3> {/* Added font-mont, changed font-bold to font-semibold */}
            <ul className="space-y-2">
              {/* TODO: Update links to be relevant public links */}
              <li>
                <Link to="/" className={`${textColorClass} ${linkHoverColorClass}`}>
                  Home
                </Link>
              </li>
              <li>
                <a 
                  href="https://hooraypower.co.za/about-us/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={`${textColorClass} ${linkHoverColorClass}`}
                >
                  About Us
                </a>
              </li>
              <li>
                <a 
                  href="https://hooraypower.co.za/contact/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={`${textColorClass} ${linkHoverColorClass}`}
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a 
                  href="https://hooraypower.co.za/privacy-policy/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={`${textColorClass} ${linkHoverColorClass}`}
                >
                  Privacy Statement
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className={`text-xl font-semibold mb-4 font-mont ${headingColorClass}`}>Contact Us</h3> {/* Added font-mont, changed font-bold to font-semibold */}
            <ul className="space-y-2">
              <li className={`flex items-start ${textColorClass}`}>
                {/* Added MapPinIcon */}
                <MapPinIcon className="w-5 h-5 mr-3 mt-1 flex-shrink-0" aria-hidden="true" />
                <span>2nd Floor, 20 Skeen Boulevard, Bedfordview, South Africa</span>
              </li>
              <li className={`flex items-start ${textColorClass}`}>
                {/* Added PhoneIcon */}
                <PhoneIcon className="w-5 h-5 mr-3 mt-1 flex-shrink-0" aria-hidden="true" />
                <span>+27 (0) 81 474 3328</span>
              </li>
              <li className={`flex items-start ${textColorClass}`}>
                {/* Added EnvelopeIcon */}
                <EnvelopeIcon className="w-5 h-5 mr-3 mt-1 flex-shrink-0" aria-hidden="true" />
                <span>hello@hooraypower.co.za</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 